import { Box, Card } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { LineItem } from '../../models/order-history-detail.model'
import { currencyFormatter } from '../../utils'
import { Typography } from '@e3dc-react/shell/Elements/Typography'

interface OrderHistorySubProductsProps {
  subProducts: LineItem[]
  configuratorQuantity: number
}

const useStyles = makeStyles()(theme => ({
  container: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  nameContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    minWidth: 0,
  },
  nameTextWrapper: {
    minWidth: 0,
    flexShrink: 1,
    flexGrow: 0,
  },
  quantity: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    flexShrink: 0,
  },
  headerText: {
    paddingBottom: theme.spacing(1),
  },
  priceContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    flexShrink: 0,
  },
}))

const QUANTITY_SYMBOL = 'x'

const OrderHistorySubProducts: React.FC<OrderHistorySubProductsProps> = ({ subProducts, configuratorQuantity }) => {
  const { classes } = useStyles()

  return (
    <Box>
      <Typography variant="subtitle2" className={classes.headerText}>
        {'shop.order-history.sub-product-label'}
      </Typography>
      {subProducts.map(product => {
        const productName = product.name
        const formattedPrice = currencyFormatter(product.totalPrice)
        const quantity = product.quantity / configuratorQuantity
        const productQuantity = `${quantity}${QUANTITY_SYMBOL}`
        return (
          <Card key={product.position} className={classes.container}>
            <Box className={classes.spaceBetween}>
              <Box className={classes.nameContainer}>
                <Box className={classes.nameTextWrapper}>
                  <Typography variant="subtitle2" className={classes.headerText}>
                    {'shop.order-history.sub-product-name'}
                  </Typography>
                  <Typography noWrap variant="subtitle1">
                    {productName}
                  </Typography>
                </Box>
                <Box className={classes.quantity}>
                  <Typography variant="subtitle2" className={classes.headerText}>
                    {'shop.order-history.sub-product-quantity'}
                  </Typography>
                  <Typography variant="subtitle1">{productQuantity}</Typography>
                </Box>
              </Box>
              <Box className={classes.priceContainer}>
                <Typography variant="subtitle2" className={classes.headerText}>
                  {'shop.order-history.sub-product-price'}
                </Typography>
                <Typography variant="subtitle1">{formattedPrice}</Typography>
              </Box>
            </Box>
          </Card>
        )
      })}
    </Box>
  )
}

export default OrderHistorySubProducts
